import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { SelectField } from '@mews-commander/legacy-form';
import { getSubscriptionOptions } from '../../selectors/settings';

const SubscriptionSelectField = connect(
    createStructuredSelector({
        options: getSubscriptionOptions,
    })
)(SelectField);

(SubscriptionSelectField as $TSFixMe).defaultProps = {
    name: 'subscription',
    label: <LocalizedText textKey={TextKey.Subscription} />,
    required: true,
};

export default SubscriptionSelectField;
